/**
 * Created by luis on 11/7/16.
 */
(function(){

    console.log('from popup.js');

    var showedPopupInCurrentSession = [];
    /**
     * from an popup option, check if the popup can be shown,
     * the decision is made based on option value of after close
     * @param popupOption
     * @param popupOptionID
     */
    function canShow(popupOptionID, popupOption)
    {
        console.log("checking if poupp can be shown");
        var popup = jQuery('#' + popupOption.popupID);
        console.log("popup ID is: ", popupOption.popupID);
        console.log("can we show again: ", popupOption.afterClose.action);
        console.log("this was shown? ", isPopupShowedInLifeTime(popup));

        if (popupOption.afterClose.action === 'never_show' && isPopupShowedInLifeTime(popupOptionID))
        {
            console.log('popup not showing because it was set to be shown once');
            return false;
        }

        if (_.contains(showedPopupInCurrentSession, popupOptionID))
        {
            console.log('popup not showing because it was shown in current session');
            return false;
        }

        //if the popup was shown, however, it hasn't passed the hibernate period, don't show again
        if (popupOption.afterClose.action==='hide_x_day')
        {
            if (getTimePopupLastShown(popupOptionID) !== null)
            {
                var today = new Date();
                var timeDiff = Math.abs(today.getTime() - getTimePopupLastShown(popupOptionID).getTime());
                console.log("time diff is: ", timeDiff);
                var diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                console.log("Days difference is: ", diffDays);

                if (diffDays < popupOption.afterClose.daysToHide)
                    return false;
            }
        }

        //1. if the popup has shown in current session, don't show it again

        //in case
        return true;
    }

    /**
     * get the value of last_showed of popup in the localstorage object, return null if not available
     * @param popupOptionID
     */
    function getTimePopupLastShown(popupOptionID)
    {
        var objectList = getWPLXShownPopups();
        if (typeof objectList[popupOptionID] === 'undefined')
            return null;
        if (typeof objectList[popupOptionID].last_showed === 'undefined')
            return null;

        //last_showed is the string value of the last time the popup was showed
        return new Date(objectList[popupOptionID].last_showed);

    }

    /**
     * get the object of shown popup stored in localstorage
     * @returns {any}
     */
    function getWPLXShownPopups()
    {
        return JSON.parse(localStorage.getItem('wplx_list_shown_popups') || "{}");
    }

    function isPopupShowedInLifeTime(popupOptionID)
    {
        var recordedOptions = getWPLXShownPopups();
        console.log("recorded option", recordedOptions);
        console.log("popup id: ", popupOptionID);
        return  (typeof recordedOptions[popupOptionID] !== 'undefined');
    }

    /**
     * record popups options that showed in this format:
     * {
     *  popup_option_id :
     *  {
     *      last_showed: 'time that popup last showed'
     *  }
     * }
     * @param popupOptionID
     */
    function recordPopupShowed(popupOptionID)
    {
        var string = localStorage.getItem('wplx_list_shown_popups') || "{}";
        var recordedOptions =  [];

        try {
            recordedOptions = JSON.parse(string);
        } catch (err)
        {
            console.error(err);
            localStorage.setItem('wplx_list_shown_popups', '{}');
        }


        showedPopupInCurrentSession.push(popupOptionID);
        console.log('list of popup showen in current sessino' , showedPopupInCurrentSession);

        recordedOptions[popupOptionID] = { 'last_showed' : (new Date()).toISOString() };
        localStorage.setItem('wplx_list_shown_popups', JSON.stringify(recordedOptions));

    }

    jQuery(function(){
        var trackingObject = trackingObject || {};
        /**
         * currentSessionPopupShowed is set to false on every session (page, visit)
         * It prevents the popup from showing up multiple time in one page load
         */

        function showPopup(popup, displayOption)
        {
            var popupOptionID = popup.attr('data-popup-option-id');

            if (!canShow(popupOptionID, displayOption))
            {

                return;
            } else
            {
                console.log("we can show it: ", popupOptionID, " and the display option: ", displayOption);
            }

            console.log("popup option is: ", displayOption);

            //create session ID
            var sessionID = c37GenerateSessionID();
            trackingObject[popupOptionID] = sessionID;
            console.log('tracking object', trackingObject);

            //send hit event
            // c37TrackingPopupOpen(popupOptionID, sessionID, 'popup');

            recordPopupShowed(popupOptionID);


            let innerElement = popup.find('.c37-lp-popup-inner').first();




            let completeClass = '';


            switch(displayOption.positionOnPage)
            {

                case 'top_left':

                    completeClass = 'c37-popup-top-left';
                    break;
                case 'top_right':

                    completeClass = 'c37-popup-top-right';
                    break;
                case 'bottom_left':
                    completeClass = 'c37-popup-bottom-left';
                    break;
                case 'bottom_right':
                    completeClass = 'c37-popup-bottom-right';
                    break;
                case 'center':
                    completeClass = 'c37-popup-center';
                    break;
                case 'center-top':
                    completeClass = 'c37-popup-center-top';
                    break;
                case 'center-bottom':
                    completeClass = 'c37-popup-center-bottom';
                    break;

                case 'center-left':
                    completeClass = 'c37-popup-center-left';
                    break;

                case 'center-right':
                    completeClass = 'c37-popup-center-right';
                    break;

                default:
                    completeClass = 'c37-popup-center';
                    break;
            }




            /* DISABLE ALL ANIMATIONS FOR NOW */
            popup.removeClass('c37-d-none');


            popup.css('display', 'block');
            // if (displayOption.animation === 'default')
            // {
            //     console.info('popup show using basic animation, no bounce');
            //     // popup.show();
            //
            // }
            // else {
            //     //show the poup but set visibility to 0, use bounce to show it
            //
            //     popup.removeClass('c37-d-none');
            //
            //     console.info('set display to block');
            //     popup.css('display', 'block');
            //
            //     innerElement.removeClass('c37-hide-popup-slide-left');
            //     innerElement.removeClass('c37-hide-popup-slide-right');
            //     innerElement.removeClass('c37-hide-popup-slide-bottom');
            //     innerElement.removeClass('c37-hide-popup-slide-top');
            //
            //     let innerPopupWidth = innerElement.width();
            //     let innerPopupHeight = innerElement.height();
            //
            //     console.log('width and height: ', innerPopupWidth);
            //     console.log('width and height: ', innerPopupHeight);
            //
            //     switch (displayOption.animation)
            //     {
            //         case 'slide_in_left':
            //             completeClass += ' animated slideInLeft';
            //             break;
            //
            //         case 'slide_in_right':
            //             completeClass += ' animated slideInRight';
            //             break;
            //
            //         case 'slide_in_top':
            //             completeClass += ' animated slideInDown';
            //             break;
            //
            //         case 'slide_in_bottom':
            //             completeClass += ' animated slideInUp';
            //             break;
            //
            //         default:
            //             completeClass += ' animated slideInLeft';
            //             break;
            //
            //     }
            //
            //     if (completeClass.indexOf('c37-popup-center-left') !== false)
            //     {
            //         innerElement.css('margin-left', 0);
            //         innerElement.css('margin-top', -innerPopupHeight/2);
            //     }
            //     else if (completeClass.indexOf('c37-popup-center-right') !== false)
            //     {
            //         innerElement.css('margin-right', 0);
            //         innerElement.css('margin-top', -innerPopupHeight/2);
            //     }
            //     else if (completeClass.indexOf('c37-popup-center')!==false)
            //     {
            //         innerElement.css('margin-left', -innerPopupWidth/2);
            //         innerElement.css('margin-top', -innerPopupHeight/2);
            //     }
            //     innerElement.addClass(completeClass);
            //
            //     // popup.show();
            //
            //
            //
            //     //calculate the inner popup x and y
            //
            //     // innerElement.addClass('animated slideInLeft');
            //     // innerElement.removeClass(completeClass);
            //
            //     // bounce.applyTo(popup.find('.c37-lp-popup-inner').first());
            // }



            jQuery(popup).trigger('resize');
            console.log('popup showed!');

            //remove the animation attribute
            // setTimeout(function(){
            //     popup.find('.c37-lp-popup-inner').first().css('animation', '');
            // }, 500);

        }

        jQuery(document).on('click', '.c37-lp-close-popup', function(){

            var popup = jQuery(this).closest('.c37-lp-popup-outer');
            var pageID = popup.attr('data-popup-option-id');
            console.log('on close, tracking object is: ', trackingObject);
            console.log('page id is : ', pageID);

            // var sessionID = trackingObject[popup.attr('data-popup-option-id')];
            // c37TrackingPopupClose(pageID, sessionID);
            jQuery(this).closest('.c37-lp-popup-outer').remove();
        });

        //the howToShowUp settings is printed when create the popup (c37-popup-manager)
        if (typeof howToShowUp !== 'undefined')
        {
            var display = howToShowUp;

            _.each(display, function(d){
                var popup = jQuery('#'+d.popupID);

                console.log('popup css id is: ', d.popupID);


                if (d.hideMobile && d.hideDesktop)
                {
                    console.info("popup was set to hide on mobile and desktop");
                    return;
                }
                else if (d.hideMobile)
                {
                    console.info('popup was set to hide on mobile')
                    if (c37isMobile)
                        return;
                } else if (d.hideDesktop)
                {
                    console.info('popup was set to hide on Desktop')
                    if (!c37isMobile)
                        return;
                }

                if (d.howToShowUp.trigger === 'mouse_exits')
                {
                    jQuery(document).on('mouseleave', function(e){
                        console.log(e.clientY);
                        if (e.clientY < 100)
                        {
                            console.log('showing popup on mouse leave, exit intent');
                            showPopup(popup, d);
                            jQuery(window).trigger('resize');
                        }

                    });
                } else if (d.howToShowUp.trigger === 'after_page_load')
                {
                    console.log("timer is: ", d);
                    setTimeout(function(){
                        console.log('showing popup on page load');
                        showPopup(popup, d);
                        //send a fake resize event so the background can update and fill the whole page
                        jQuery(window).trigger('resize');
                    }, d.howToShowUp.delay * 1000);
                } else if (d.howToShowUp.trigger === 'vertical_scroll')
                {
                    console.log('popup is set to show on vertical scroll');
                    //don't show the popup if the trigger is undefined
                    var scrollObject = d.howToShowUp.scroll;
                    if (typeof scrollObject.trigger === 'undefined')
                    {
                        console.error('trigger is undefined!');
                        return;
                    }

                    //if user set the trigger to scroll to a specific pixel, create a
                    //scroll listener and trigger the popup
                    if (scrollObject.trigger === 'pixel')
                    {
                        var scrollListener = typeof scrollObject.scrollEventListener === "undefined" || scrollObject.scrollEventListener === "" ? window : scrollObject.scrollEventListener;

                        if (scrollListener === "document")
                            scrollListener = document;

                        console.log(scrollObject);

                        console.log('Scroll listener is: ' + scrollListener);

                        jQuery(scrollListener).on('scroll', function(){

                            var distanceFromTop;
                            //in case the use set an element for scrolling, use of offset of that element
                            //to trigger

                            if (typeof scrollObject.element !== "undefined" && scrollObject.element !=="")
                            {
                                distanceFromTop = Math.abs(jQuery(scrollObject.element).offset().top);
                            } else
                            {
                                distanceFromTop = jQuery('body').scrollTop();
                            }

                            console.log('distance from top is: ' + distanceFromTop + 'px');

                            if (distanceFromTop >= scrollObject.pixel)
                            {
                                console.log('showing popup on scroll');
                                showPopup(popup, d);
                            }

                        });

                    }

                }

            });



        }
        //close the popup on the button/any element with class c37-close-popup clicked


    });

})();